var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showView&&_vm.isTenantId)?_c('div',{staticClass:"app-wrap"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1):_vm._e(),(!_vm.isWap&&_vm.isTenantId)?_c('bottombar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }